export default {"src":"/_next/static/media/logo-mark.218b1d32.svg","height":42,"width":96};